module.exports = "assets/64d16f3d78cccdf0be94ef47f999aba8.glb";